import {
  Box,
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Button,
} from "@mui/material";
import { useState } from "react";

const AcademicParentInfo = ({
  academicInfo,
  setAcademicInfo,
  parentInfo,
  setParentInfo,
  handleBack,
  handleNext,
  commonContainerStyle,
}) => {
  const [errors, setErrors] = useState({});

  const uiFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "6px",
      "& fieldset": { borderColor: "#c9c9c9" },
      "&:hover fieldset": { borderColor: "#9d9d9d" },
      "&.Mui-focused fieldset": { borderColor: "#000" },
    },
    "& .MuiFormHelperText-root": { color: "#d32f2f" },
  };

  // ---------------------------
  //   VALIDATION FUNCTION
  // ---------------------------
  const validateFields = () => {
    let tempErrors = {};

    // Academic Info Required
    if (!academicInfo.school_name) tempErrors.school_name = "Required";
    if (!academicInfo.school_board) tempErrors.school_board = "Required";
    // if (!academicInfo.previous_class_score)
    //   tempErrors.previous_class_score = "Required";

    // Parent Info Required
    if (!parentInfo.father_first_name)
      tempErrors.father_first_name = "Required";
    if (!parentInfo.father_last_name) tempErrors.father_last_name = "Required";
    if (!parentInfo.mother_first_name)
      tempErrors.mother_first_name = "Required";
    if (!parentInfo.mother_last_name) tempErrors.mother_last_name = "Required";
    if (!parentInfo.father_occupation)
      tempErrors.father_occupation = "Required";
    if (!parentInfo.mother_occupation)
      tempErrors.mother_occupation = "Required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // ---------------------------------------
  //  HANDLE NEXT – prevent if invalid
  // ---------------------------------------
  const onNextClick = (e) => {
    if (validateFields()) {
      handleNext(e);
    }
  };

  return (
    <Box
      sx={{
        ...commonContainerStyle,
        backgroundColor: "#d8f1f6",
        padding: { xs: 3, sm: 5 },
        borderRadius: "40px 40px 0 0",
        minHeight: "100vh",
      }}
    >
      <Grid container spacing={3}>
        {/* Main Section Heading */}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: { xs: "22px", sm: "24px", md: "28px" },
              fontWeight: 600,
              mb: 3,
            }}
          >
            Academic Information
          </Typography>
        </Grid>

        {/* School Name */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            School Name*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter previous school name"
            sx={uiFieldStyles}
            value={academicInfo.school_name}
            onChange={(e) =>
              setAcademicInfo({ ...academicInfo, school_name: e.target.value })
            }
            error={!!errors.school_name}
            helperText={errors.school_name}
          />
        </Grid>

        {/* School Board */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Board*
          </Typography>

          <FormControl
            fullWidth
            sx={uiFieldStyles}
            error={!!errors.school_board}
          >
            <Select
              value={academicInfo.school_board}
              displayEmpty
              onChange={(e) =>
                setAcademicInfo({
                  ...academicInfo,
                  school_board: e.target.value,
                })
              }
            >
              <MenuItem value="" disabled>
                Select board
              </MenuItem>
              <MenuItem value="CBSE">CBSE</MenuItem>
              <MenuItem value="ICSE">ICSE</MenuItem>
              <MenuItem value="State Board">State Board</MenuItem>
            </Select>

            {errors.school_board && (
              <FormHelperText>{errors.school_board}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        {/* Percentage */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Percentage in previous class*
          </Typography>

          <TextField
            fullWidth
            type="number"
            placeholder="Enter %"
            sx={uiFieldStyles}
            value={academicInfo.previous_class_score}
            onChange={(e) =>
              setAcademicInfo({
                ...academicInfo,
                previous_class_score: e.target.value,
              })
            }
            error={!!errors.previous_class_score}
            helperText={errors.previous_class_score}
          />
        </Grid> */}

        {/* Parent Section */}
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: { xs: "22px", sm: "24px", md: "28px" },
              fontWeight: 600,
              mt: 4,
            }}
          >
            Parent / Guardian Information
          </Typography>
        </Grid>

        {/* Name */}
        <Grid item xs={12} md={12}>
          <Typography variant="subtitle1" sx={{ mb: 0, fontWeight: 600 }}>
            Father's Name*
          </Typography>
        </Grid>

        {/* First Name */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Enter first name"
            sx={uiFieldStyles}
            value={parentInfo.father_first_name}
            onChange={(e) =>
              setParentInfo({
                ...parentInfo,
                father_first_name: e.target.value,
              })
            }
            error={!!errors.father_first_name}
            helperText={errors.father_first_name}
          />
        </Grid>

        {/* Last Name */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Enter last name"
            sx={uiFieldStyles}
            value={parentInfo.father_last_name}
            onChange={(e) =>
              setParentInfo({ ...parentInfo, father_last_name: e.target.value })
            }
            error={!!errors.father_last_name}
            helperText={errors.father_last_name}
          />
        </Grid>

        {/* Occupation */}
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Father's Occupation*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter occupation"
            sx={uiFieldStyles}
            value={parentInfo.father_occupation}
            onChange={(e) =>
              setParentInfo({
                ...parentInfo,
                father_occupation: e.target.value,
              })
            }
            error={!!errors.father_occupation}
            helperText={errors.father_occupation}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography variant="subtitle1" sx={{ mb: 0, fontWeight: 600 }}>
            Mother's Name*
          </Typography>
        </Grid>

        {/* First Name */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Enter first name"
            sx={uiFieldStyles}
            value={parentInfo.mother_first_name}
            onChange={(e) =>
              setParentInfo({
                ...parentInfo,
                mother_first_name: e.target.value,
              })
            }
            error={!!errors.mother_first_name}
            helperText={errors.mother_first_name}
          />
        </Grid>

        {/* Last Name */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            placeholder="Enter last name"
            sx={uiFieldStyles}
            value={parentInfo.mother_last_name}
            onChange={(e) =>
              setParentInfo({ ...parentInfo, mother_last_name: e.target.value })
            }
            error={!!errors.mother_last_name}
            helperText={errors.mother_last_name}
          />
        </Grid>

        {/* Occupation */}
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Mother's Occupation*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter occupation"
            sx={uiFieldStyles}
            value={parentInfo.mother_occupation}
            onChange={(e) =>
              setParentInfo({
                ...parentInfo,
                mother_occupation: e.target.value,
              })
            }
            error={!!errors.mother_occupation}
            helperText={errors.mother_occupation}
          />
        </Grid>

        {/* Contact Number */}
        {/* <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Mobile Number*
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter contact number"
            sx={uiFieldStyles}
            value={parentInfo.contact_number}
            onChange={(e) =>
              setParentInfo({ ...parentInfo, contact_number: e.target.value })
            }
            error={!!errors.contact_number}
            helperText={errors.contact_number}
          />
        </Grid> */}

        {/* Email (optional) */}
        {/* <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Email Address
          </Typography>

          <TextField
            fullWidth
            placeholder="Enter email"
            sx={uiFieldStyles}
            value={parentInfo.email_address}
            onChange={(e) =>
              setParentInfo({ ...parentInfo, email_address: e.target.value })
            }
          />
        </Grid> */}

        {/* Footer */}
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={5}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              color: "black",
              borderColor: "black",
              "&:hover": { backgroundColor: "#f0f0f0", borderColor: "#333" },
            }}
          >
            Go Back
          </Button>

          <Box display="flex" alignItems="center" gap={2}>
            <Typography sx={{ fontSize: "12px" }}>*imp fields</Typography>

            <Button
              variant="contained"
              onClick={(e) => onNextClick(e)}
              sx={{
                backgroundColor: "#2C2C2C",
                color: "white",
                padding: "6px 28px",
                borderRadius: "6px",
                "&:hover": { backgroundColor: "#444" },
              }}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AcademicParentInfo;
